import { sortBy } from 'lodash'

import { GraphStackResponse, GraphBucketResponse, GraphCompareResponse } from 'src/api/gen/api'
import { formatDateExport, spreadBy } from 'src/commons/export/Export'
import { getTranslation } from 'src/commons/i18n'
import { enumsTranslationKeys } from 'src/commons/i18nEnums'
import { GranularityEnum, IFeature } from 'src/commons/types'
// Max number of areas for device deployed diagram
// We keep the ones with highest in-area traffic
export const MAX_DISPLAYED_AREAS = 20
// Graph DeployedPerProviderComponent
export function formatDeployedPerProvider(granularity: GranularityEnum) {
  const { t } = getTranslation()
  return (bucket: GraphCompareResponse) => {
    // Bucket ordered by provider_name.
    //
    // Note: Doing this is valid since javascript objects keep the insertion
    //       order for string keys when iterated over.
    // See: https://stackoverflow.com/a/5525820/6864469
    const orderedBuckets = sortBy(bucket.compareBy.buckets, 'key')

    return {
      [t('kpi.export.Date')]: formatDateExport(bucket.key, granularity),
      ...spreadBy(orderedBuckets),
      [t('kpi.export.AverageForAllProviders')]: bucket.average,
    }
  }
}

// Component DeployedMapComponent
export function formatExportDeploymentMap() {
  const { t } = getTranslation()
  return (feature: IFeature) => ({
    [t('kpi.export.Area')]: feature.properties.label,
    [t('kpi.export.NumberOfVehiclesDeployed')]: feature.properties.value,
    [t('kpi.export.PercentageVehicleDeployedInArea')]: feature.properties.percentage,
  })
}
export function formatAverageFleetSizePerProvider(granularity: GranularityEnum) {
  const { t } = getTranslation()
  return (bucket: GraphCompareResponse) => {
    const orderedBuckets = sortBy(bucket.compareBy.buckets, 'key')

    return {
      [t('kpi.export.Date')]: formatDateExport(bucket.key, granularity),
      ...spreadBy(orderedBuckets),
    }
  }
}
export function formatAverageFleetSizePerProviderOnRange() {
  const { t } = getTranslation()

  return (bucket: GraphBucketResponse) => ({
    [t('kpi.export.Provider')]: bucket.key,
    [t('kpi.export.AverageFleetSize')]: bucket.doc_count,
  })
}
// Graph FleetAvailabilityComponent
export function formatExportFleetAvailability(granularity: GranularityEnum) {
  const { t } = getTranslation()
  return (bucket: GraphBucketResponse) => ({
    [t('kpi.export.Date')]: formatDateExport(bucket.key, granularity),
    [t('kpi.export.Ratio') + ' (%)']: bucket.doc_count,
  })
}

// Graph DevicessPerStatusComponent
export function formatExportDevicesPerStatus(granularity: GranularityEnum) {
  const { t } = getTranslation()
  const translateStatus = (status: string) => t(enumsTranslationKeys.VehicleStates[status])
  return (bucket: GraphStackResponse) => {
    return {
      [t('kpi.export.Date')]: formatDateExport(bucket.key, granularity),
      ...spreadBy(bucket.stackedBy.buckets, undefined, true, translateStatus),
      Total: bucket.doc_count,
    }
  }
}
